export const DROPDOWN_OPTIONS = {
    STRATEGY_SORT_OPTIONS: [
        { value: 'grp_name', label: 'Name' },
        { value: 'capital_required', label: 'Capital Required' },
        { value: 'is_subscribed', label: 'Subscription Status' }
    ],
    MY_STRATEGY_SORT_OPTIONS: [
        { value: 'grp_name', label: 'Name' },
        { value: 'capital_required', label: 'Capital Required' },
        { value: 'grpbr_trading_flag', label: 'Trading Status' },
        { value: 'lots', label: 'Lot Size' },
        { value: 'end_date', label: 'Expiry Date' },

    ],
    JSON_BRIDGE_SORT_OPTION: [
        { value: "json_bridge_name", label: "Name" },
        { value: "og_connection_name", label: "Connected name" },
        { value: "og_is_connected", label: "Connection status" },
        { value: "og_place_order", label: "Trading status" },
    ],
    ORDER_MANAGER_SORT_OPTION: [
        { value: "og_connection_name", label: "Group/Broker Name" },
        { value: "og_tgt_value", label: "Combined Target" },
        { value: "og_sl_value", label: "Combined Stoploss" },
    ],

    AGE_RANGE_OPTION: [
        { value: "Below 18", label: "Below 18 years" },
        { value: "18-30", label: "18 - 30 years" },
        { value: "30-50", label: "30 - 50 years" },
        { value: "Above 50", label: "Above 50 years" }
    ],
    PLACE_ORDER_SCRIPT_TYPE: [
        { value: "EQ", label: "Equity" },
        { value: "CE", label: "CE" },
        { value: "PE", label: "PE" },
        { value: "FUT", label: "Future" },
    ],
    PLACE_ORDER_ORDER_OPTION: [
        { value: "MARKET", label: "Market" },
        { value: "LIMIT", label: "Limit" },
        { value: "SL", label: "SL" },
    ],
    PLACE_ORDER_PRODUCT_OPTION: [
        { value: 'INTRADAY', label: 'INTRADAY' },
        { value: 'CARRYFORWARD', label: 'CARRYFORWARD' },
        { value: 'DELIVERY', label: 'DELIVERY' },
        { value: 'MARGIN', label: 'MARGIN' },
    ],
    ORDER_ACTION_OPTION: [
        { value: 'BUY', label: "BUY" },
        { value: 'SELL', label: "SELL" },
    ],
    ORDER_STATUS_OPTIONS: [
        { value: "pending", label: "Pending" },
        { value: "completed", label: "Completed" },
        { value: "cancelled", label: "Cancelled" },
        { value: "rejected", label: "Rejected" },
        { value: "failed", label: "Failed" },
    ],
    ORDER_HISTORY_FROM_OPTION: [
        { value: 'manual', label: 'Manual' },
        { value: 'copytrading', label: 'Copy Trading' },
        { value: 'ordermanager', label: 'Order Manager' },
        { value: 'bridge', label: 'Bridge' },
        { value: 'api', label: 'API' }

    ],

    WALLET_TRANSACTION_OPTION: [
        { value: 'credit', label: 'Credit' },
        { value: 'debit', label: 'Debit' }
    ],
    ORDER_PRODUCT_OPTION: [
        { value: 'INTRADAY', label: 'INTRADAY' },
        { value: 'CARRYFORWARD', label: 'CARRYFORWARD' },
        { value: 'DELIVERY', label: 'DELIVERY' },
        { value: 'MARGIN', label: 'MARGIN' },
    ],
    JSON_BRIDGE_SL_TGT_TYPE_OPTION: [
        { value: 'LTP', label: 'LTP' },
        { value: 'POINT', label: 'POINT' },
        { value: 'PERCENTAGE', label: 'PERCENTAGE' },
    ],
    JSON_BRIDGE_TRAIL_TYPE_OPTIONS: [
        { value: 'LTP', label: 'LTP' },
        { value: 'POINT', label: 'POINT' },
        { value: 'PERCENTAGE', label: 'PERCENTAGE' }
    ],
    ORDER_SL_TGT_TYPE_OPTION: [
        { value: 'LTP', label: 'LTP' },
        { value: 'CANDLE', label: 'CANDLE' },
        { value: 'PERCENTAGE', label: 'PERCENTAGE' },
        { value: 'POINT', label: 'POINT' },
    ],
    ORDER_SL_TGT_DIRECTION_TYPE_OPTION: [
        { value: 'ABOVE', label: 'ABOVE' },
        { value: 'BELOW', label: 'BELOW' },
    ],
    ORDER_ENTRY_TYPE_OPTION: [
        { value: 'DIRECT', label: 'DIRECT' },
        { value: 'LTP', label: 'LTP' },
        { value: 'CANDLE', label: 'CANDLE' },
    ],
    ORDER_EXPIRY_TYPE_OPTION: [
        { value: "monthly", label: "Monthly" },
        { value: "weekly", label: "Weekly" },
    ],
    ORDER_SCRIPT_TYPE_OPTION: [
        { value: "EQ", label: "Equity" },
        { value: "CE", label: "CE" },
        { value: "PE", label: "PE" },
        { value: "FUT", label: "Future" },
    ],
    ORDER_CANDLE_TIMEFRAME_OPTION: [
        { value: 1, label: '1 Min' },
        { value: 2, label: '2 Min' },
        { value: 3, label: '3 Min' },
        { value: 5, label: '5 Min' },
        { value: 10, label: '10 Min' },
        { value: 15, label: '15 Min' },
        { value: 30, label: '30 Min' },
        { value: 60, label: '60 Min' }
    ],
    ORDER_OPTION_SELECTION_TYPE_OPTION: [
        { value: "SYMBOL_BASED", label: "Symbol Based" },
        { value: "PREMIUM_BASED", label: "Premium Based" },
        { value: "ATM_BASED", label: "ATM Based" },
    ],
};


export const DEFAULT_SETTINGS = {
    DATE_FORMAT: 'dd-MM-yyyy',
    PAYLOAD_DATE_FORMAT: 'yyyy-MM-dd',
    DATE_TIME_FORMAT: 'yyyy-MM-dd HH:mm:ss',
    TIME_FORMAT: "HH:mm:ss",

};

export const STORAGE_KEYS = {
    BROKER_PANEL_USER_ACCESS_TOKEN: "BROKER_PANEL_USER_ACCESS_TOKEN",
    BROKER_PANEL_USER_CONNECTION_KEY: "BROKER_PANEL_USER_CONNECTION_KEY",
    BROKER_PANEL_USER_REMEMBER_ME: "BROKER_PANEL_USER_REMEMBER_ME",
    BROKER_PANEL_USER_IS_LOGGIN_IN: "BROKER_PANEL_USER_IS_LOGGIN",
    LINK_USER_CONNECTION_KEY: "LINK_USER_CONNECTION_KEY",
    WALLET_TABLE_KEY: 'BP_USER_WALLET_TBL',
    ACTIVITY_LOG_TABLE_KEY: 'BP_USER_ACTIVITY_LOGS',
    TRADE_TABLE_KEY: 'BP_USER_TRADE_TBL',
    POSITION_TABLE_KEY: 'BP_USER_POSITION_TBL',
    ORDER_TABLE_KEY: 'BP_USER_ORDER_TBL',
    STRATGEY_RECORD_TABLE_KEY: 'BP_USER_STRATEGY_RECORD_TBL',
    STRATGEY_ORDER_HISTORY_TABLE_KEY: 'BP_USER_STRATEGY_ORDER_HISTORY_TBL',
    REFERRAL_USER_TABLE_KEY: 'BP_USER_REFERRAL_USER_TBL',
    REFERRAL_EARNING_TABLE_KEY: 'BP_USER_REFERRAL_EARNING_TBL',
    ORDER_HISTORY_TABLE_KEY: 'BP_USER_ORDER_HISTORY_TBL',
    USER_PERMISSION: 'BP_USER_PERMISSION',
    CONFIGS: 'BP_USER_CONFIGS'

}

export const LOGO_TYPE = {
    HORIZONTAL_LOGO: 'horizontal_logo',
    VERTICAL_LOGO: 'vertical_logo',
    LOGIN_BG: 'login_bg'
}
export const API_RESPONSE_TYPE = {
    OTP: 'otp',
    OTP_EXPIRED: 'otp-expired',
    OTP_INVALID: 'otp-invalid',
    EMAIL_USED: 'email-used',
}
export const RECAPTCHA_ACTIONS = {
    LOGIN: "LOGIN",
    REGISTRATION: "REGISTRATION",
    FORGOT_PASSWORD: "FORGOTPASSWORD",
};
export const TRANSACTION_TYPE = {
    CREDIT: 'credit',
    DEBIT: 'debit'
}
export const ORDER_TYPE = {
    LIMIT: 'LIMIT',
    MARKET: 'MARKET',
    SL: 'SL'
}
export const DEMAT_INFO_TABS = {
    POSITIONS: "Positions",
    ORDERS: 'Orders',
    TRADES: 'Trades'
}
export const UPDATE_ORDER_TYPE = {
    CANCEL: "cancel",
    MODIFY: 'modify',
    CONVERTTOMARKET: 'converttomarket'
}
export const ORDER_STATUS = {
    COMPLETD: 'completed',
    REJECTED: 'rejected',
    CANCELLED: 'cancelled',
    PENDING: 'pending',
    FAILED: 'failed'
}
export const STRATEGY_DETAILS_TAB = {
    RECORDS: 'Records',
    ORDERS: "Orders"
}
export const REFERRAL_TAB = {
    REFERRAL_USERS: 'Referral Users',
    REFERRAL_EARNING: 'Referral Earning'
}
export const STATIC_IP_STATUS = {
    AVAILABLE: 'available',
    CONNECTED: 'connected',
    EXPIRED: 'expired',
    DELETED: 'deleted'
}

export const REFERRAL_CODE = 'referral'
export const PARTENR_ID = 'partner_id'

export const CONNECTION_KEY = 'connection_key'
export const STRATEGY_SEARCH_KEYWORD = ["grp_name", "description"];
export const JSON_BRIDGE_SEARCH_KEYWORD = ["json_bridge_name", "og_connection_name"]
export const ORDER_MANAGER_SEARCH_KEYWORDS = ["og_connection_name"]

export const JSON_ORDER_TYPE = {
    STRATEGY: 'strategy_order',
    LIMIT: 'limit_order',
    SL: 'sl_order',
    CANCEL: 'cancel_order',
    SQAUREOFF: 'squareoff_position',

}
export const JSON_BRIDGE_SIMULATION = 'json_bridge_simulation'

export const JSON_BRIDGE_TABS = [
    { key: JSON_ORDER_TYPE.STRATEGY, label: 'Strategy Order' },
    { key: JSON_ORDER_TYPE.LIMIT, label: 'Limit Order' },
    { key: JSON_ORDER_TYPE.SL, label: 'SL Order' },
    { key: JSON_ORDER_TYPE.SQAUREOFF, label: 'SquareOff Position' },
    { key: JSON_ORDER_TYPE.CANCEL, label: 'Cancel Order' },
    { key: JSON_BRIDGE_SIMULATION, label: 'Simulation' }
]

export const JSON_FIELDS = {
    TYPE: 'type',
    SCRIPT_TYPE: "script_type",
    OPTION_SELECTION: "option_selection",
    SCRIPT: "script",
    PREMIUM_VALUE: "premium_value",
    MAX_VARIATION: "max_variation",
    ATM_GAP: "atm_gap",
    EXPIRY_GAP: "expiry_gap",
    EXPIRY_TYPE: "expiry_type",
    PRODUCT: "product",
    QUANTITY: "quantity",
    TRANSACTION_TYPE: "transaction_type",
    PRICE: "price",
    TRIGGER_PRICE: "trigger_price",
    EXIT_ON_OPPOSITE: "exit_on_opposite",
    IS_TGT: "is_tgt",
    IS_SL: "is_sl",
    IS_TRAIL: "is_trail_set",
    IS_ROLLOVER: "is_rollover",
    ROLLOVER_GAP: "rollover_gap",
    ROLLOVER_TIME: "rollover_time",
    TGT_TYPE: "tgt_type",
    TGT_VALUE: "tgt_value",
    SL_TYPE: "sl_type",
    SL_VALUE: "sl_value",
    TRAIL_TYPE: "trail_type",
    TRAIL_TRIGGER: "trail_trigger",
    TRAIL_GAP: "trail_gap",
    TRAIL_POINT: "trail_point",
    POSITION_SIZE: 'position_size'
}

export const ORDER_SCRIPT_TYPE = {
    EQ: "EQ",
    CE: 'CE',
    PE: 'PE',
    FUT: 'FUT',

}
export const ORDER_OPTION_SELECTION_TYPE = {
    SYMBOL_BASED: "SYMBOL_BASED",
    PREMIUM_BASED: "PREMIUM_BASED",
    ATM_BASED: "ATM_BASED"
}
export const JSON_BRIDGE_DROPDWON_OPTIONS = {
    [JSON_FIELDS.SCRIPT_TYPE]: DROPDOWN_OPTIONS.ORDER_SCRIPT_TYPE_OPTION,
    [JSON_FIELDS.OPTION_SELECTION]: DROPDOWN_OPTIONS.ORDER_OPTION_SELECTION_TYPE_OPTION,
    [JSON_FIELDS.PRODUCT]: DROPDOWN_OPTIONS.ORDER_PRODUCT_OPTION,
    [JSON_FIELDS.EXPIRY_TYPE]: DROPDOWN_OPTIONS.ORDER_EXPIRY_TYPE_OPTION,
    [JSON_FIELDS.TGT_TYPE]: DROPDOWN_OPTIONS.JSON_BRIDGE_SL_TGT_TYPE_OPTION,
    [JSON_FIELDS.SL_TYPE]: DROPDOWN_OPTIONS.JSON_BRIDGE_SL_TGT_TYPE_OPTION,
    [JSON_FIELDS.TRAIL_TYPE]: DROPDOWN_OPTIONS.JSON_BRIDGE_TRAIL_TYPE_OPTIONS
}
export const ORDER_GROUP_UPDATE_TYPE = {
    TGT: "TGT",
    SL: "SL",
    TRADING: "TRADING",
    START_TIME: "START_TIME",
    END_TIME: "END_TIME"
}
export const ORDER_GROUP_STATUS = {
    WAITING: 'WAITING',
    OPEN: 'OPEN'
}
export const ORDER_SL_TGT_TYPE = {
    CANDLE: 'CANDLE',
    LTP: 'LTP',
    PERCENTAGE: 'PERCENTAGE',
    POINT: 'POINT',
    DIRECT: 'DIRECT',
    NONE: "NONE"
}
export const ORDER_SL_TGT_DIRECTION_TYPE = {
    ABOVE: 'ABOVE',
    BELOW: 'BELOW'
}
export const ODRER_MANAGER_COMBINED_TARGET_SL_STATUS = {
    GROUP_TGT: 'GROUP_TGT',
    GROUP_SL: 'GROUP_SL'
}

export const PAYMENT_TYPE = {
    BANK: 'BANK',
    PHONEPE: 'PHONEPE'
}